// 检验是否是URL链接
export const isUrl = (str: string) => /^https?:\/\//.test(str);
